export default __webpack_public_path__ + "static/media/iconWaitingCircle.d9604968.svg";